import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppSolicitudesBolsa } from '../../core/models/appSolicitidesBolsa.model';
import { AppSolicitudesBolsaService } from '../../core/services/appSolicitudesBolsa.service';
import { AppImagenes } from '../../core/models/appImagenes.model';
import { AppDocumentos } from '../../core/models/appDocumentos.model';
import { AppSolicitudesService } from '../../core/services/appSolicitudes.service';
import { getAcronymNameById } from '../helpers/acronymTypes.js';
import { AppA3DocService } from '../../core/services/appA3Doc.service';
import { CalendarioComponent } from '../calendario/calendario.component';
import { DOCUMENT } from '@angular/common';
import { LivesSessionHelper } from '../../core/helper/livesSessionHelper';
@Component({
  selector: 'app-accept-reject-dialog',
  templateUrl: './accept-reject-dialog.component.html',
  styleUrls: ['./accept-reject-dialog.component.scss'],
  providers: [AppSolicitudesBolsaService, AppSolicitudesService, AppA3DocService]
})
export class AcceptRejectDialogComponent {

  panelIcon = 'event_available'; // Material icon
  panelTitle = 'Solicitud';
  panelTitleTwo = 'Solicitud de bolsa';
  panelDescription = 'Observaciones de la solicitud';

  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  showScrollDown = true;

  holidayBagReq: AppSolicitudesBolsa;

  id: string;
  currentPage: number = 0;  // Página actual
  fullName: string;
  company: string;
  companyId: string;
  typeName: string;
  lessThanOneDay: string;
  startDate: string;
  endDate: string;
  duration: string;
  observations: string;
  validator: string;
  dualValidator: string;
  hrValidators: string;
  validatedByHr: string;
  stateValue: string;
  hrStateValue: string;
  dualStateValue: string;
  state: number;
  hrState: number;
  dualState: number;
  createdAt: Date;
  validationDate: Date;
  validationHrDate: Date;
  dualValidationDate: Date;
  a3Doc: { associatedA3doc: string, mimeType: string, name: string, docData: string } = { associatedA3doc: null, mimeType: null, name: null, docData: null };
  doc: AppDocumentos;
  image: AppImagenes;
  isChecked = false;
  observationsValidator: string;
  observationsEmployee: string;
  holidayBag: string;
  holidayBagId: string;
  requestedAmount: string;
  currentAmount: string;
  currentRealAmount: string;
  holidayBagState: number;
  validationBagDate: Date;
  enabledValidator = false;

  //Personal Requests
  innuvaPersonalRequest1: string;
  innuvaScheduledDate: string;
  innuvaScheduledDone: string;
  innuvaEmail: string;
  innuvaOldEmail: string;
  innuvaBankAccount: string;
  innuvaOldBankAccount: string;

  innuvaAcronym: string;
  innuvaOldAcronym: string;
  innuvaBuildingNumber: string;
  innuvaOldBuildingNumber: string;
  innuvaFloor: string;
  innuvaOldFloor: string;
  innuvaCountryName: string;
  innuvaOldCountryName: string;
  innuvaStreetName: string;
  innuvaOldStreetName: string;
  innuvaStairwell: string;
  innuvaOldStairwell: string;
  innuvaGate: string;
  innuvaOldGate: string;
  innuvaPostalCode: string;
  innuvaOldPostalCode: string;

  //Advances Requests

  advanceRequest1: string;
  advanceRequestedAmount: string;
  advanceCurrentAmount: string;
  advanceState: string;
  advanceValidator: string;




  data: any[]; // Array de datos, cada elemento es una 'página'
  calendarData: any[]; // Array de datos para el calendario
  showAccepted = false;
  showRejected = false;
  showHolidayBagAccepted = false;
  showHolidayBagRejected = false;
  enabledHolidayBagValidator = false;



  constructor(
    public dialogRef: MatDialogRef<AcceptRejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    @Inject(DOCUMENT) private document: Document,
    private appSolicitudesBolsaService: AppSolicitudesBolsaService,
    private appSolicitudesService: AppSolicitudesService,
    private appA3DocService: AppA3DocService,
    protected _acceptRejectPopUp: MatDialog,
    private renderer: Renderer2,
    private _livesSession: LivesSessionHelper
  ) {
    this.calendarData = inputData.calendarData;
    this.data = inputData.data;
    this.data.forEach((item) => {
      item.isChecked = false;
      item.showAccepted = false;
      item.showRejected = false;
      item.associatedHolidayBag && (item.associatedHolidayBag.showHolidayBagAccepted = false);
      item.associatedHolidayBag && (item.associatedHolidayBag.showHolidayBagRejected = false);
    });
    this.getPageData();
    this.holidayBagReq = new AppSolicitudesBolsa();

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.detectScroll();
    }, 0);

  }

  ngAfterViewInit() {
    this.scrollableSection.nativeElement.addEventListener('scroll', this.detectScroll.bind(this));
  }

  ngOnDestroy() {
    this.scrollableSection.nativeElement.removeEventListener('scroll', this.detectScroll.bind(this));
  }

  //activar y desactivar el botón de scroll hasta el final
  detectScroll(): void {
    const element = this.scrollableSection.nativeElement;

    // Posición actual del scroll
    const scrollPosition = element.scrollTop;

    // Altura del contenedor
    const clientHeight = element.clientHeight;

    // Altura total del contenido en el contenedor
    const scrollHeight = element.scrollHeight;

    // Comprobar si hay scroll o no
    if (scrollHeight === clientHeight) {
      this.showScrollDown = false;
    } else {
      this.showScrollDown = true;
    }

    // Comprobar si hemos llegado al final del contenedor
    if (scrollPosition + clientHeight >= scrollHeight) {
      this.showScrollDown = false;
    }
  }


  scrollDown() {
    const scrollElement = document.getElementById('focusBottom');
    if (scrollElement) {
      scrollElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }


  getTitle() {
    const currentData = this.data[this.currentPage];
    const id = currentData?.type || '';
    const additionalInfoData = [];
    let additionalInfo = '';

    // Check and append 'Email' if available
    if (currentData.associatedPersonalRequest?.email) {
      additionalInfoData.push('Email');
    }

    // Check and append 'Banco' if available
    if (currentData.associatedPersonalRequest?.bankAccount) {
      additionalInfoData.push('Banco');
    }

    if (currentData.associatedPersonalRequest?.acronym || currentData.associatedPersonalRequest?.streetName || currentData.associatedPersonalRequest?.buildingNumber || currentData.associatedPersonalRequest?.stairwell || currentData.associatedPersonalRequest?.floor || currentData.associatedPersonalRequest?.gate || currentData.associatedPersonalRequest?.postalCode || currentData.associatedPersonalRequest?.countryId) {
      additionalInfoData.push('Dirección');

    }

    if (additionalInfoData.length > 0) {
      additionalInfo = ` (${additionalInfoData.join(', ')})`;
    }

    return `${this.panelTitle} (${id}) ${additionalInfo}`;
  }

  getTitleHolidayReq() {
    const id = this.requestedAmount || '';


    return `${this.panelTitleTwo} (${id})`;
  }



  getFullName() {
    const currentData = this.data[this.currentPage];
    return `${currentData.Name} ${currentData.Surname}`
  }



  checkDate(date1: string, date2: string) {
    //compruebo si son o no iguales
    if (date1 == date2) {
      return `${date1} `;
    } else {
      return `${date1} - ${date2}`;
    }
  }

  updateIsChecked(event: any) {
    // Verificar si el clic proviene del usuario
    if (event.event) {
      const currentData = this.data[this.currentPage];
      currentData.isChecked = !currentData.isChecked; // Cambiar el estado del checkbox
    }
  }

  onOpenCalendar() {
    const currentData = this.data[this.currentPage];
    const dialogRef = this._acceptRejectPopUp.open(CalendarioComponent, {
      width: '100%',
      data: {
        appointments: this.calendarData,
        preFilters: { tipo: [], empleado: [], empresa: [currentData.company.name], estado: ['Pendiente', 'Aprobado'], centro: [] }, // Filtros iniciales
        disableEdit: true,
        startDate: currentData.startDate
      }
    });

    setTimeout(() => {
      this.applyDialogStyles([0, 1]);
    });

    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.removeDialogStyles([0, 1]);
      }, 300);
    });

  }

  downloadResource(data: any, doc: boolean = false) {
    const byteCharacters = atob(doc ? data.docData : data.imageData);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.mimeType });

    const url = URL.createObjectURL(blob);

    // Crear un elemento de enlace para la descarga
    const a = document.createElement('a');
    a.href = url;
    a.download = data.name;
    document.body.appendChild(a);
    a.click();

    // Limpiar y remover el enlace cuando haya terminado
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  rejectRequest() {
    const currentData = this.data[this.currentPage];

    this.sendData(false);
    this.showRejected = true;
    currentData.showRejected = true;
    this.holidayBag && this.rejectHolidayBagRequest(false);
    !this.holidayBag && this.nextPage();
  }

  acceptRequest() {
    const currentData = this.data[this.currentPage];

    this.sendData(true);
    this.showAccepted = true;
    currentData.showAccepted = true;
    !this.holidayBag && this.nextPage()

  }

  rejectHolidayBagRequest(nextPageAllowed: boolean = true) {
    const currentData = this.data[this.currentPage];

    this.sendHolidayBagData(false);
    this.showHolidayBagRejected = true;
    currentData.showHolidayBagRejected = true;

    nextPageAllowed && this.nextPage()
  }

  acceptHolidayBagRequest() {
    const currentData = this.data[this.currentPage];

    this.sendHolidayBagData(true);
    this.showHolidayBagAccepted = true;
    currentData.showHolidayBagAccepted = true;
    this.nextPage()
  }

  nextPage() {
    if (this.currentPage < this.data.length - 1) {
      this.currentPage++;
      this.clearObservationsFields()
      this.getPageData();

      this.scrollToTop();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.clearObservationsFields()
      this.getPageData();

      this.scrollToTop();
    }
  }


  scrollToTop() {
    const element = this.scrollableSection.nativeElement;
    element.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  closePopUp() {
    this.dialogRef.close();
  }

  getCurrentHRValidator(hrValidatorsData: any, userId: string) {

    const validator = hrValidatorsData.find(validator => validator.hostelUserId === userId);

    // Si se encuentra un validador, concatena y devuelve el nombre y apellido
    if (validator) {
      return `${validator.name} ${validator.surname}`;
    }

    const allValidatorsNames = hrValidatorsData.map(validator => `${validator.name} ${validator.surname}`).join(', ');
    return allValidatorsNames;
  }

  getCurrentHRValidatorId(hrValidatorsData: any, userId: string) {

    const validator = hrValidatorsData.find(validator => validator.hostelUserId === userId);

    // Si se encuentra un validador, concatena y devuelve el nombre y apellido
    if (validator) {
      return validator.hrValidator1;
    }

    // Si no se encuentra un validador con ese userid, devuelve una cadena vacía o un mensaje
    return '-1';
  }

  getPageData() {
    const userLogged = this._livesSession.AspNetUserId;
    const currentData = this.data[this.currentPage];

    this.id = currentData.request1;
    this.fullName = currentData.user.fullName;
    this.company = currentData.company.name;
    this.companyId = currentData.company.company1;
    this.typeName = currentData.type;
    this.lessThanOneDay = currentData.lessThanOneDay === true ? 'Sí' : 'No';
    this.startDate = this.getFormattedDate(currentData.startDate);
    this.endDate = this.getFormattedDate(currentData.endDate);
    this.duration = `${this.formatTime(currentData.startDate)} - ${this.formatTime(currentData.endDate)} (${currentData.duration})`;
    this.observations = currentData.employeeObservations;
    this.observationsValidator = currentData.validatorObservations;
    this.observationsEmployee = '';
    this.validatedByHr = this.getCurrentHRValidatorId(currentData.hrValidators, userLogged);
    this.hrValidators = currentData.validatedByHrData !== null ? `${currentData.validatedByHrData.name} ${currentData.validatedByHrData.surname}` : this.getCurrentHRValidator(currentData.hrValidators, userLogged);
    this.validator = currentData.validator ? currentData.validator.fullName : this.hrValidators;
    this.dualValidator = currentData.dualResponsible ? currentData.dualResponsible.fullName : '';
    this.stateValue = currentData.state.name;
    this.hrStateValue = currentData.stateHr.name;
    this.dualStateValue = currentData.stateDual?.name;
    this.state = currentData.state.requestState1;
    this.hrState = currentData.stateHr.requestState1;
    this.dualState = currentData.stateDual?.requestState1;

    if (currentData?.associatedA3doc) {
      this.a3Doc.associatedA3doc = currentData?.associatedA3doc;

      this.appA3DocService.getDoc(currentData.associatedA3doc)
        .then(result => {
          this.a3Doc.docData = result.content;
          this.a3Doc.name = ` ${currentData.user.fullName}-${currentData.associatedA3doc}`;
          this.a3Doc.mimeType = 'application/pdf';
        })
        .catch(error => {
          console.error('Error al obtener documento', error);
        });
    }
    
    this.doc = currentData.associatedDoc?.doc1 ? currentData.associatedDoc : null;
    this.image = currentData.associatedImage?.image1 ? currentData.associatedImage : null;
    this.isChecked = currentData.isChecked;
    this.showAccepted = currentData.showAccepted;
    this.showRejected = currentData.showRejected;

    this.createdAt = currentData.createdAt;
    this.validationDate = currentData.validationDate;
    this.validationHrDate = currentData.validationHrDate;
    this.dualValidationDate = currentData.dualValidationDate;

    this.enabledValidator = !currentData.associatedAdvanceRequest ? this.getCurrentHRValidatorId(currentData.hrValidators, userLogged) !== '-1' ?? false : userLogged === currentData.associatedAdvanceRequest.validatedByData.hostelUserId;
    this.holidayBag = currentData.associatedHolidayBag ? currentData.associatedHolidayBag.holidayBag1 : null;

    //si existe solicitud de bolsa obtengo sus datos
    if (currentData.associatedHolidayBag
      != null) {
      this.holidayBagId = currentData.associatedHolidayBag.holidayBag1;
      this.currentAmount = this.formatCurrency(currentData.associatedHolidayBag.currentAmount);
      this.currentRealAmount = this.formatCurrency(currentData.associatedHolidayBag.proportionalAmount);
      this.requestedAmount = this.formatCurrency(currentData.associatedHolidayBag.requestedAmount);
      this.holidayBagState = currentData.associatedHolidayBag.state;
      this.showHolidayBagAccepted = currentData.showHolidayBagAccepted;
      this.validationBagDate = currentData.associatedHolidayBag.validationBagDate;
      this.enabledHolidayBagValidator = currentData.associatedHolidayBag.holidayBagValidatorData?.hostelUserId === userLogged ?? false;
    }

    if (currentData.associatedPersonalRequest
      != null) {
      this.innuvaPersonalRequest1 = currentData.associatedPersonalRequest;
      this.innuvaScheduledDate = currentData.associatedPersonalRequest.bankAccount ? this.getFormattedDate(currentData.scheduledDate, true) : null;
      this.innuvaScheduledDone = currentData.associatedPersonalRequest.bankAccount ? currentData.scheduledDone ? 'Reaalizado' : 'Pendiente' : null;
      this.innuvaEmail = currentData.associatedPersonalRequest.email;
      this.innuvaOldEmail = currentData.associatedPersonalRequest.oldEmail;
      this.innuvaBankAccount = currentData.associatedPersonalRequest.bankAccount && this.formatIBAN(currentData.associatedPersonalRequest.bankAccount);
      this.innuvaOldBankAccount = currentData.associatedPersonalRequest.oldBankAccount && this.formatIBAN(currentData.associatedPersonalRequest.oldBankAccount);

      this.innuvaAcronym = getAcronymNameById(currentData.associatedPersonalRequest.acronym);
      this.innuvaOldAcronym = currentData.associatedPersonalRequest.oldAcronym;
      this.innuvaBuildingNumber = currentData.associatedPersonalRequest.buildingNumber;
      this.innuvaOldBuildingNumber = currentData.associatedPersonalRequest.oldBuildingNumber;
      this.innuvaFloor = currentData.associatedPersonalRequest.floor;
      this.innuvaOldFloor = currentData.associatedPersonalRequest.oldFloor;
      this.innuvaCountryName = currentData.associatedPersonalRequest.countryName;
      this.innuvaOldCountryName = currentData.associatedPersonalRequest.oldCountryName;
      this.innuvaStreetName = currentData.associatedPersonalRequest.streetName;
      this.innuvaOldStreetName = currentData.associatedPersonalRequest.oldStreetName;
      this.innuvaStairwell = currentData.associatedPersonalRequest.stairwell;
      this.innuvaOldStairwell = currentData.associatedPersonalRequest.oldStairwell;
      this.innuvaGate = currentData.associatedPersonalRequest.gate;
      this.innuvaOldGate = currentData.associatedPersonalRequest.oldGate;
      this.innuvaPostalCode = currentData.associatedPersonalRequest.postalCode;
      this.innuvaOldPostalCode = currentData.associatedPersonalRequest.oldPostalCode;


    }


    if (currentData.associatedAdvanceRequest) {
      this.advanceRequest1 = currentData.associatedAdvanceRequest.advanceRequest1;
      this.advanceCurrentAmount = this.formatCurrency(currentData.associatedAdvanceRequest.currentAmount);
      this.advanceRequestedAmount = this.formatCurrency(currentData.associatedAdvanceRequest.requestedAmount);
      this.advanceState = currentData.associatedAdvanceRequest.state.name;
      this.advanceValidator = currentData.associatedAdvanceRequest.validatedByData.name + ' ' + currentData.associatedAdvanceRequest.validatedByData.surname;
    }

  }

  clearObservationsFields() {
    this.observationsValidator = '';
    this.observationsEmployee = '';
    this.observations = '';
  }


  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value);
  }

  formatIBAN(value: string) {
    const cleanValue = value.replace(/\s+/g, ''); // Elimina espacios existentes
    const match = cleanValue.match(/^(\w{1,4})(\w{1,4})(\w{1,4})?(\w{1,2})?(.*)?/);
    if (!match) return value;

    let formatted = match[1];
    if (match[2]) {
      formatted += ` ${match[2]}`;
    }
    if (match[3]) {
      formatted += ` ${match[3]}`;
    }
    if (match[4]) {
      formatted += ` ${match[4]}`;
    }
    if (match[5]) {
      formatted += ` ${match[5]}`;
    }
    return formatted;
  };


  getFormattedDate(dateInput: string | Date, monthYear: boolean = false): string {
    const date = new Date(dateInput);
    const options: Intl.DateTimeFormatOptions = { month: 'long' };

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11 en JavaScript
    const monthLong = date.toLocaleDateString('es-ES', options);
    const year = date.getFullYear();

    if (monthYear) {
      return `${monthLong.charAt(0).toUpperCase() + monthLong.slice(1).toLowerCase()} ${year}`;
    } else {
      return `${day}/${month}/${year}`;
    }
  }

  sendHolidayBagData(accepted: boolean) {
    let dataToUpdate = {
      state: accepted ? 1 : 2
    }

    this.appSolicitudesBolsaService.updateModel(this.holidayBagId, dataToUpdate).subscribe(
      (response) => {
        // console.log(response)
      },
      (error) => {

        console.error('Error al modificar la solicitud', error)
      }
    )
  }

  sendData(accepted: boolean) {
    let observationsValidatorText = '';
    let observationsEmployeeText = '';


    if (this.observations) {
      observationsEmployeeText += `${this.fullName}: ${this.observations}`;
    }

    if (this.observationsEmployee) {
      if (this.observationsEmployee) {
        observationsEmployeeText += "\n";
      }
      observationsEmployeeText += `${this.hrValidators}: ${this.observationsEmployee}`;
    }

    if (this.observationsValidator) {
      if (this.observations) {
        observationsValidatorText += `${this.fullName}: ${this.observations}`;
        observationsValidatorText += "\n";
      }
      observationsValidatorText += `${this.hrValidators}: ${this.observationsValidator}`;
    }



    let dataToUpdate = {
      validatorObservations: observationsValidatorText,
      employeeObservations: observationsEmployeeText,
      stateHr: accepted ? 1 : 2,
      company: this.companyId,
      validatedByHr: this.validatedByHr
    }

    if (this.isChecked) {
      dataToUpdate['state'] = accepted ? 1 : 2
      if (this.dualValidator) {

        dataToUpdate['stateDual'] = accepted ? 1 : 2

      }
    }

    let advancesDataToUpdate = {
      state: accepted ? 1 : 2
    }

    if (this.advanceRequest1) {

      this.appSolicitudesService.updateAdvanceRequest(this.advanceRequest1, advancesDataToUpdate).subscribe(
        (response) => {
          // console.log(response)
        },
        (error) => {

          console.error('Error al modificar la solicitud', error)
        }
      )
    } else {


      this.appSolicitudesService.updateModel(this.id, dataToUpdate).subscribe(
        (response) => {
          // console.log(response)
        },
        (error) => {

          console.error('Error al modificar la solicitud', error)
        }
      )
    }
  }


  private applyDialogStyles(indexes: number[]) {
    const dialogContainers = this.document.querySelectorAll('.mat-dialog-container');
    indexes.forEach(index => {
      if (dialogContainers[index]) {
        this.renderer.setStyle(dialogContainers[index], 'background-color', '#dadada');
        this.renderer.setStyle(dialogContainers[index], 'max-height', '90vh');
        this.renderer.setStyle(dialogContainers[index], 'overflow-y', 'auto');
        this.renderer.addClass(dialogContainers[index], 'scrollable-section');
      }
    });
  }

  private removeDialogStyles(indexes: number[]) {
    const dialogContainers = this.document.querySelectorAll('.mat-dialog-container');
    indexes.forEach(index => {
      if (dialogContainers[index]) {
        this.renderer.removeStyle(dialogContainers[index], 'max-height');
        this.renderer.removeStyle(dialogContainers[index], 'overflow-y');
        this.renderer.removeClass(dialogContainers[index], 'scrollable-section');
      }
    });
  }

  private formatTime(date: any) {
    if (!(date instanceof Date)) {
      date = new Date(date); // Intenta convertirlo a Date
    }
    return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });
  }


}